export default function () {
    const wrap = '.top-menu-bar';
    const enterElem = `${wrap} .tab .list__link`;
    const $tabContent = $('.tab-content');
    const tabContentItem = '.tab-content__item';
    const listItem = '.list__item';
    const showClass = 'show';
    const active = 'is-active';

    $(document).on({
        mouseenter: (e) => {
            let $target = $(e.currentTarget);
            let idContentItem = $target.data('item');

            if (!idContentItem) {
                $tabContent.removeClass(showClass);
                $(listItem, wrap).removeClass(active);

                return;
            }

            $(listItem, wrap).removeClass(active);
            $(tabContentItem, wrap).removeClass(showClass);

            if (!$tabContent.hasClass(showClass)) {
                $tabContent.addClass(showClass);
            }

            $target.closest(listItem).addClass(active);
            $(`#${idContentItem}`).addClass(showClass);
        },
    }, enterElem);

    $(document).on({
        mouseleave: () => {
            $tabContent.removeClass(showClass);
            $(listItem, wrap).removeClass(active);
        },
    }, wrap);
}
